import { useCallback } from 'react';
import moment from 'moment';

const formatDateDigits = (value) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length === 8)
        return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
    return value;
};

const formatTimeDigits = (value) => {
    const digits = value.replace(/\D/g, '');
    // 4자리: 0900 → 09:00
    if (digits.length === 4)
        return `${digits.slice(0, 2)}:${digits.slice(2, 4)}`;
    // 콜론 포함 H:MM 형식 입력 시 zero-pad: 9:00 → 09:00
    const match = value.match(/^(\d{1,2}):(\d{2})$/);
    if (match) return `${String(match[1]).padStart(2, '0')}:${match[2]}`;
    return value;
};

export const isValidDate = (val) => !!val && /^\d{4}-\d{2}-\d{2}$/.test(val) && moment(val, 'YYYY-MM-DD', true).isValid();
export const isValidTime = (val) => {
    if (!val || !/^\d{1,2}:\d{2}$/.test(val)) return false;
    const [h, m] = val.split(':').map(Number);
    return h >= 0 && h <= 23 && m >= 0 && m <= 59;
};

/**
 * @param {object} opts
 * @param {function} opts.dateKeyMatcher  - (dataKey) => boolean, 날짜 컬럼 여부
 * @param {string}   [opts.empKey]        - 사번 컬럼 키
 * @param {string}   [opts.startKey]      - 근무 시작시간 컬럼 키
 * @param {string}   [opts.endKey]        - 근무 종료시간 컬럼 키
 * @param {Array}    [opts.allUserList]   - 전체 직원 목록
 */
const useWorkGridCell = ({ dateKeyMatcher, empKey, startKey, endKey, allUserList = [], empNoSet } = {}) => {
    const formatCell = useCallback((dataKey, value) => {
        if (dateKeyMatcher?.(dataKey)) return formatDateDigits(value);
        if ((startKey && dataKey === startKey) || (endKey && dataKey === endKey)) return formatTimeDigits(value);
        return value;
    }, [dateKeyMatcher, startKey, endKey]);

    const validateCell = useCallback((dataKey, raw) => {
        const val = String(raw ?? '').trim();
        if (dateKeyMatcher?.(dataKey)) return !isValidDate(val);
        if (empKey && dataKey === empKey) {
            if (!val) return true;
            return empNoSet ? !empNoSet.has(val) : !allUserList.some(u => u.companyNumber === val);
        }
        if (startKey && dataKey === startKey) return !isValidTime(val);
        if (endKey && dataKey === endKey) return !isValidTime(val);
        return false;
    }, [dateKeyMatcher, empKey, startKey, endKey, empNoSet]);

    return { formatCell, validateCell };
};

export default useWorkGridCell;
